import { LoadingPlaceholder } from '../../../../../../../components/LoadingPlaceholder/index';
import { ReactComponent as KeyIcon } from '../../../../../../../assets/icons/invitationIcons/keyIcon.svg';

export const InvitationCodeContent = ({ inviteCode }: { inviteCode: string }) => {
  return (
    <div>
      <div className="flex text-primary-p3 mb-4">
        <KeyIcon className="shrink-0" />
        <span className="font-semibold leading-6 pl-2">
          Provide the patient with the following invitation code
        </span>
      </div>
      <LoadingPlaceholder isLoading={!inviteCode}>
        <div className="font-semibold">{inviteCode}</div>
      </LoadingPlaceholder>
    </div>
  );
};
